import React from 'react';

const TemplateModal = ({ 
  show,
  publicTemplates,
  loadingTemplates,
  selectedTemplate,
  setSelectedTemplate,
  newDocumentName,
  setNewDocumentName,
  onClose,
  onSubmit
}) => {
  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-download me-2"></i>
              Importar Plantilla Pública
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <p className="text-muted">
                Selecciona una plantilla predefinida y créate una copia personal que podrás modificar según tus necesidades.
              </p>
            </div>
            
            {loadingTemplates ? (
              <div className="text-center py-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando plantillas...</span>
                </div>
              </div>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label">Seleccionar Plantilla *</label>
                  <select
                    className="form-select"
                    value={selectedTemplate}
                    onChange={(e) => setSelectedTemplate(e.target.value)}
                  >
                    <option value="">-- Selecciona una plantilla --</option>
                    {publicTemplates.map(template => (
                      <option key={template.id} value={template.id}>
                        {template.nombre} ({template.campos.length} campos)
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Nombre para tu documento *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newDocumentName}
                    onChange={(e) => setNewDocumentName(e.target.value)}
                    placeholder="Ej: Mi Oficio Personalizado"
                  />
                  <div className="form-text">
                    Este será el nombre de tu copia personal que podrás modificar
                  </div>
                </div>

                {selectedTemplate && publicTemplates.find(t => t.id === parseInt(selectedTemplate)) && (
                  <div className="alert alert-info">
                    <h6 className="alert-heading">
                      <i className="bi bi-info-circle me-2"></i>
                      Vista previa de la plantilla
                    </h6>
                    {(() => {
                      const template = publicTemplates.find(t => t.id === parseInt(selectedTemplate));
                      return (
                        <>
                          <p className="mb-2"><strong>Descripción:</strong> {template.descripcion}</p>
                          <p className="mb-2"><strong>Campos incluidos:</strong></p>
                          <ul className="mb-0">
                            {template.campos.sort((a, b) => a.orden - b.orden).map(campo => (
                              <li key={campo.id}>
                                <strong>{campo.nombre}:</strong> {campo.especificacion}
                              </li>
                            ))}
                          </ul>
                        </>
                      );
                    })()}
                  </div>
                )}
              </>
            )}
          </div>
          <div className="modal-footer">
            <div className="row w-100 g-2">
              <div className="col-6">
                <button 
                  type="button" 
                  className="btn btn-secondary btn-sm w-100" 
                  onClick={onClose}
                >
                  Cancelar
                </button>
              </div>
              <div className="col-6">
                <button 
                  type="button" 
                  className="btn btn-primary btn-sm w-100" 
                  onClick={onSubmit}
                  disabled={!selectedTemplate || !newDocumentName.trim() || loadingTemplates}
                >
                  <i className="bi bi-download me-2"></i>
                  Crear Mi Copia
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateModal;
